/* eslint-disable no-unused-vars */
// eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars
import { Button, Grid } from "@mui/material";
import { grey, orange, purple } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({});

const ActionButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
});

export default function MPaymentOptions(props) {
  const { t } = useTranslation();
  const translate = t;
  props.pRefs.optionPanel = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType) {
    if (eventType === "ArrowUp") {
      moveUp();
    } else if (eventType === "ArrowDown") {
      moveDown();
    }
  }
  function moveUp() {
    let curr = getCurPosition();
    if (curr == 0) {
      onOptionClicked(props.paymentOptions.length - 1);
    } else {
      onOptionClicked(curr - 1);
    }
  }
  function moveDown() {
    let curr = getCurPosition();
    if (curr == props.paymentOptions.length - 1) {
      onOptionClicked(0);
    } else {
      onOptionClicked(curr + 1);
    }
  }

  function getCurPosition() {
    for (let i = 0; i < props.paymentOptions.length; i++) {
      if (props.paymentOptions[i].selected) return i;
    }
    return 0;
  }

  function onOptionClicked(index) {
    let dat = [...props.paymentOptions];
    let i = 0;
    for (let d of dat) {
      if (i == index) d.selected = true;
      else d.selected = false;
      i++;
    }
    props.setPaymentOptions(dat);
  }

  return (
    <div style={{ padding: 0, paddingRight: 0 }}>
      {props.paymentOptions.map((option, index) =>
        option.code != "CREDIT" ||
        (props.customerBean && props.customerBean.creditCustomer) ? (
          <Grid
            item
            xs={12}
            style={{
              height: props.context.appMode === "desktop-pos" ? "70px" : "50px",
              paddingTop: 2,
            }}
            key={"actiButton" + index}
          >
            <ActionButton
              style={{
                background: option.selected ? orange[700] : grey[700],
              }}
              onClick={() => {
                onOptionClicked(index);
              }}
              onKeyDown={(event) => {
                //event.preventDefault();
                //event.stopPropagation();
              }}
            >
              {option.value}
            </ActionButton>
          </Grid>
        ) : null
      )}
    </div>
  );
}
